import { Auth, API } from 'aws-amplify';

const requestHeaders = async () => {
  return {
    'Content-Type': 'application/json',
    Authorization: `${(await Auth.currentSession())
      .getAccessToken()
      .getJwtToken()}`
  };
};

/* eslint-disable-next-line */
const listUsersInGroup = async function({ dispatch, getters, commit }, payload) {
  let path = '/listUsersInGroup';
  let groupname = payload.groupname;
  let limit = payload.limit;
  let token = payload.token;
  try {
    let payload = {
      queryStringParameters: {
        groupname,
        limit,
        token
      },
      headers: await requestHeaders()
    };
    let req = await API.get('AdminQueries', path, payload);
    if (req && req.Users) {
      return req;
    }
    throw Error('Error listing users.');
  } catch (error) {
    throw Error(error);
  }
};

export default listUsersInGroup;
